import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import DotView from './DotView'

const ConnectedDotLink = styled(Link)`
display: block;
text-decoration: none;
color: inherit;
font-weight: 600;

:hover {
transform: scale(1.1);
}

transition: all 0.2s 0s ease-out;
`

const ConnectedDotLinkView = props => {
  const { connectedDot, ...rest } = props
  return <ConnectedDotLink to={'/' + connectedDot.bad_collectionId() + '/' + connectedDot.id} {...rest}><DotView connectedDot={connectedDot} /></ConnectedDotLink>
}

export default ConnectedDotLinkView


// WEBPACK FOOTER //
// ./src/App/View/ConnectedDotLinkView.js